import { render, staticRenderFns } from "./wy-auto-qa-form-threshold-section.vue?vue&type=template&id=15b7ca36&"
import script from "./wy-auto-qa-form-threshold-section.vue?vue&type=script&lang=js&"
export * from "./wy-auto-qa-form-threshold-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports